// TODO use location instead of window.location.pathname
export function getPathnameLocationUtil () {
  return window.location.pathname || ''
}
